// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"274":"ef7d2799","488":"a133d7ae","745":"2858cc24"}[chunkId] + ".chunk.js";
};